"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _P = _interopRequireDefault(require("../../Typography/P"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-size: 90%;\n\tmargin-top: ", ";\n\tcolor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var InputError = (0, _styledComponents.default)(_P.default)(_templateObject(), function (props) {
  return props.size === 'small' ? '-0.4em' : '-0.25em';
}, _colors.default.error);
InputError.displayName = 'InputError';
var _default = InputError;
exports.default = _default;